// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1831":"4a5a72b1","3660":"4a5a72b1","4448":"4a5a72b1","5193":"4a5a72b1","5532":"3b150a99","5987":"4a5a72b1","6144":"4a5a72b1","6719":"4a5a72b1","8211":"4a5a72b1"}[chunkId] + ".chunk.css";
};